import BlogItem from '../../../components/blog/BlogItem';

interface Props {
    items: []
}

const Posts: React.FC<Props> = (props) => {
    return <>
        {props.items?.map((item: any) => {
            return <BlogItem
            key={`blog-item-${item.id}`}
            id={item.id}
            link={"/blog/" + item.id}
            title={item.title}
            image={item.image}
            description={item.summary}
            comments={item.comments}
            date={item.date} />
        })}
    </>
}

export default Posts